<apx-chart
  *ngIf="(chartDef.data | json) != '{}'; else noData"
  class="flex-auto w-full h-full"
  [chart]="chartOptions.chart"
  [labels]="chartOptions.labels"
  [plotOptions]="chartOptions.plotOptions"
  [dataLabels]="chartOptions.dataLabels"
  [responsive]="chartOptions.responsive"
  [tooltip]="chartOptions.tooltip"
  [series]="chartOptions.series"
  [colors]="chartOptions.colors"
  [legend]="chartOptions.legend"
></apx-chart>
<ng-template #noData>
  <p class="font-bold text-md text-secondary uppercase tracking-wider text-center p-4">
    Insufficient data to display graph
  </p>
</ng-template>
